/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
'SolitaireShared/CardLogic/DealData',[],function () {
	var DealData = function (seed, script) {
		this.Script = script;
		this.Seed = seed;
	};

	return DealData;
});
